import { Lens } from '@dhmk/zustand-lens';

export type UserRole = 'user' | 'admin' | 'entity';

export interface SelectedUserConfigSlice {
  selectedUserRole: UserRole;
  setSelectedUserRole: (_role: UserRole) => void;
  selectedEntityId: string | null;
  setSelectedEntityId: (_id: string | null) => void;
  isReferralProgramStarted: boolean;
  setIsReferralProgramStarted: (_value: boolean) => void;
  resetState: () => void;
}
const initialState = {
  selectedUserRole: 'user',
  selectedEntityId: null,
  isReferralProgramStarted: false,
} as const;

export const createSelectedUserConfigStore: Lens<SelectedUserConfigSlice> = (set) => ({
  ...initialState,
  setSelectedUserRole: (role) =>
    set((state) => {
      state.selectedUserRole = role;
      if (role !== 'entity') state.selectedEntityId = null;
    }),
  setSelectedEntityId: (id) =>
    set((state) => {
      state.selectedEntityId = id;
    }),
  setIsReferralProgramStarted: (value) =>
    set((state) => {
      state.isReferralProgramStarted = value;
    }),
  resetState: () => set(() => initialState),
});
